import { Outlet } from "react-router-dom";
import MangaNavbar from "./MangaNavbar";
import MangaFooter from "./MangaFooter";
import ScrollToTop from "./ScrollToTop";

export default function SiteLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <ScrollToTop />
      <MangaNavbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <MangaFooter />
    </div>
  );
}